var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-lk-breadcrumbs"},_vm._l((_vm.breadcrumbs),function(item,index){return _c('router-link',{key:'breadcrumbs' + index,staticClass:"t-lk-breadcrumbs__item",attrs:{"to":item.link}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/lk-breadcrumbs/lk-breadcrumbs.vue?vue&type=template&id=546bff12&
// module id = 1373
// module chunks = 0